<template>
  <div class="message-reactions-container" v-if="!isMessageDeleted">
    <div class="message-reactions" v-if="groupedReactions.length > 0">
      <div class="reaction-badge" @click="toggleDropdown">
        <span
          class="reaction-emoji"
          v-for="reaction in groupedReactions"
          :key="reaction.emoji"
        >{{ reaction.emoji }}</span>
        <span class="reaction-count" v-if="totalCount > 1">{{ totalCount }}</span>
      </div>

      <!-- Reaction Dropdown -->
      <div class="reaction-dropdown" v-if="showDropdown">
        <div
          class="reaction-dropdown-row"
          v-for="item in reactions"
          :key="item.UserID + item.Emoji"
          :class="{ 'own-reaction': isMyReaction(item) }"
          @click="isMyReaction(item) && removeReaction(item.Emoji)"
        >
          <span class="reaction-dropdown-emoji">{{ item.Emoji }}</span>
          <img class="reaction-dropdown-photo" :src="getUserPhoto(item.UserID)" />
          <div class="reaction-dropdown-info">
            <div class="reaction-dropdown-name">{{ getUser(item.UserID).VisibleName || getUser(item.UserID).UserName || item.UserID }}</div>
            <div class="reaction-dropdown-remove" v-if="isMyReaction(item)">Tepkiyi kaldirmak icin tikla</div>
          </div>
        </div>
      </div>
    </div>
    <div class="reaction-add-btn" @click="$emit('open-picker')">
      <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" fill="#b0b0b0"><path d="M480-480Zm0 400q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q43 0 83 8.5t77 24.5v90q-35-20-75.5-31.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-32-6.5-62T776-600h86q9 29 13.5 58.5T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm320-600v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80ZM620-520q25 0 42.5-17.5T680-580q0-25-17.5-42.5T620-640q-25 0-42.5 17.5T560-580q0 25 17.5 42.5T620-520Zm-280 0q25 0 42.5-17.5T400-580q0-25-17.5-42.5T340-640q-25 0-42.5 17.5T280-580q0 25 17.5 42.5T340-520Zm263.5 221.5Q659-337 684-400H276q25 63 80.5 101.5T480-260q68 0 123.5-38.5Z"/></svg>
    </div>
  </div>
</template>

<script>
import { messageMixin } from '@/mixins/messageMixin.js'

export default {
  mixins: [messageMixin],

  props: {
    reactions: {
      type: Array,
      default: () => []
    },
    message: {
      type: Object,
      default: null
    }
  },

  data () {
    return {
      showDropdown: false
    }
  },

  computed: {
    groupedReactions () {
      if (!this.reactions || this.reactions.length === 0) return []

      const myUserID = this.$store.state.session.user.UserID
      const groups = {}

      this.reactions.forEach(r => {
        if (!groups[r.Emoji]) {
          groups[r.Emoji] = { emoji: r.Emoji, count: 0, isMine: false, users: [] }
        }
        groups[r.Emoji].count++
        groups[r.Emoji].users.push(r.UserID)
        if (r.UserID === myUserID) {
          groups[r.Emoji].isMine = true
        }
      })

      return Object.values(groups)
    },

    totalCount () {
      return this.reactions ? this.reactions.length : 0
    },

    isMessageDeleted () {
      if (!this.message) return false
      const myUserID = this.$store.state.session.user.UserID
      return (this.message.DeleteStatus === 12 && this.message.From === myUserID) || this.message.Status === 12
    }
  },

  methods: {
    getUser (userID) {
      return this.$store.getters.getUserById(userID) || { UserID: userID, UserName: userID, PhotoURL: '/images/nophoto.png' }
    },
    getUserPhoto (userID) {
      const user = this.$store.getters.getUserById(userID)
      const photoURL = user ? user.PhotoURL : null

      if (!photoURL) {
        return '/images/nophoto.png'
      }

      if (photoURL.includes('http') || photoURL.includes('nophoto.png')) {
        return photoURL
      }

      if (this.$config && process.env.VUE_APP_UPLOADURL2) {
        const key = '6a61e395-b49a-4468-bee0-27644e95308f'
        const iv = key.split('').reverse().join('')
        const encryptedBody = this.ewk(photoURL, key, iv)
        return process.env.VUE_APP_UPLOADURL2 + '/gfe?fn=' + photoURL + '&s=' + encodeURIComponent(encryptedBody)
      }

      return '/images/nophoto.png'
    },
    isMyReaction (item) {
      return item.UserID === this.$store.state.session.user.UserID
    },
    toggleDropdown () {
      if (this.showDropdown) {
        this.closeDropdown()
      } else {
        this.showDropdown = true
        setTimeout(() => {
          document.addEventListener('click', this.onDocumentClick)
        }, 0)
      }
    },
    closeDropdown () {
      this.showDropdown = false
      document.removeEventListener('click', this.onDocumentClick)
    },
    onDocumentClick (e) {
      if (this.$el && !this.$el.contains(e.target)) {
        this.closeDropdown()
      }
    },
    removeReaction (emoji) {
      this.$emit('toggle-reaction', emoji)
      this.closeDropdown()
    }
  },

  beforeDestroy () {
    document.removeEventListener('click', this.onDocumentClick)
  }
}
</script>

<style lang="less" scoped>
.message-reactions-container {
  // No position: relative — so reaction-add-btn positions against the balloon
}

.message-reactions {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: -8px;
  padding: 2px 6px;
  position: relative;
  z-index: 1;
}

.reaction-badge {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 2px 6px;
  border-radius: 12px;
  background: #f0f0f0;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  transition: background 0.15s ease;
  &:hover {
    background: #e4e4e4;
  }
}

.reaction-emoji {
  line-height: 1;
  padding: 0 1px;
}

.reaction-count {
  font-size: 11px;
  color: #555;
  font-weight: 500;
}

.reaction-add-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: transparent;
  border: none;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.15s ease;
  z-index: 2;

  &:hover {
    background: rgba(0, 0, 0, 0.06);
    svg {
      fill: #888;
    }
  }
}

.reaction-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 4px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  min-width: 220px;
  max-height: 240px;
  overflow-y: auto;
  z-index: 9999;
  padding: 4px 0;
}

.reaction-dropdown-row {
  display: flex;
  align-items: center;
  padding: 6px 12px;
  gap: 8px;

  &:hover {
    background: #f5f5f5;
  }

  &.own-reaction {
    cursor: pointer;

    &:hover {
      background: #fff0f0;
    }
  }
}

.reaction-dropdown-emoji {
  font-size: 18px;
  flex-shrink: 0;
}

.reaction-dropdown-photo {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.reaction-dropdown-info {
  flex: 1;
  min-width: 0;
}

.reaction-dropdown-name {
  font-size: 13px;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.reaction-dropdown-remove {
  font-size: 11px;
  color: #999;
  opacity: 0.7;
  transition: all 0.15s ease;
}

.reaction-dropdown-row.own-reaction:hover .reaction-dropdown-remove {
  color: #e53935;
  opacity: 1;
}
</style>

<style lang="less">
// Received messages: button on the right
.messageBalloonMain .reaction-add-btn {
  right: -32px;
}
// Sent messages: button on the left
.messageBalloonMainReverse .reaction-add-btn {
  left: -32px;
}
// Sent messages: reaction badges aligned to right edge of the balloon
.messageBalloonMainReverse .message-reactions {
  justify-content: flex-end;
}
// Sent messages: dropdown aligned to right edge
.messageBalloonMainReverse .reaction-dropdown {
  left: auto;
  right: 0;
}
// Show on hover
.messageBalloonMain:hover .reaction-add-btn,
.messageBalloonMainReverse:hover .reaction-add-btn {
  opacity: 1;
}
</style>
